import {DependencyList, EffectCallback, useEffect, useRef} from "react";

/**
 * Hook that works like useEffect but skips the first render
 * Useful when you want to run effect only on updates, not on mount
 */
export const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList): void => {
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        return effect();
    }, deps);
};
